import api from '../../../services/Api';
import { IAuditoriaAdiantamentoSalarioResultado } from '../interfaces/IAuditoriaAdiantamentoSalario';

export const AuditoriaAdiantamentoSalarioService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaAdiantamentoSalarioResultado> {
    const response = await api.get<IAuditoriaAdiantamentoSalarioResultado>('auditoria-adiantamento-salario/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        adiantamentosPendentes: [],
        adiantamentosConciliados: [],
      }
    );
  },
};
